import { render } from "./MenuVertical.vue?vue&type=template&id=74aaf11f&scoped=true"
import script from "./MenuVertical.vue?vue&type=script&lang=js"
export * from "./MenuVertical.vue?vue&type=script&lang=js"

import "./MenuVertical.vue?vue&type=style&index=0&id=74aaf11f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74aaf11f"]])

export default __exports__